import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllvendorExcessThunk = createAsyncThunk(
    'excess/getAllvendorExcessThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllvendorExcess(config);
            //   console.log("nnnnn",response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getvendorExcessStatisticsThunk = createAsyncThunk(
    'excess/getvendorExcessStatisticsThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getvendorExcessStatisticsdata(config);
              console.log("staticssssssss",response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const vendorExcessDetailsThunk = createAsyncThunk(
    'excess/vendorExcessDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getvendorExcessDetails(id);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportvendorExcessThunk = createAsyncThunk(
    'order/exportvendorExcessThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllvendorExcess(config);
              console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deletevendorExcessThunk = createAsyncThunk(
    'order/deletevendorExcessThunk',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deletevendorExcess(id);
            dispatch(setvendorExcessrefresh())
            toast.success('excess enquiry deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete excess enquiry')
        }
    }
);


export const updateVendorExcessstatusThunk = createAsyncThunk(
    'order/updateStatus',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updatevendorExcessStatus(data);
            dispatch(setvendorExcessrefresh())
            toast.success('order updated  successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to update order')
        }
    }
);


export const deleteProductFromVendorExcessThunk = createAsyncThunk(
    'wizard/deleteProductFromExcessThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteProductFromvendorExcess(data);
            dispatch(setvendorExcessrefresh())
            toast.success('product deleted from enquiry  successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete product')
        }
    }
);

const vendorExcessSlice = createSlice({
    name: 'vendorExcess',
    initialState: {
        excess: [],
        orderDetails: {},
        orderStatistics: {
            data: {},
            loading: false
        },
        refresh: false,
        loading: false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setvendorExcessrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setvendorExcessPage: (state, action) => {
            state.page = action.payload
        },
        setvendorExcessSearch: (state, action) => {
            state.search = action.payload
        },
        setvendorExcessStatus: (state, action) => {
            state.status = action.payload
        },
        setvendorExcessFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setvendorExcessToDate: (state, action) => {
            state.toDate = action.payload
        },
        setvendorExcessSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setvendorExcessData: (state, action) => {
            state.orderDetails = {
                ...state.orderDetails, // Keep existing fields
                products: action.payload, // Update only products
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllvendorExcessThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllvendorExcessThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.excess = action.payload;
            })
            .addCase(getAllvendorExcessThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(vendorExcessDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(vendorExcessDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orderDetails = action.payload;
            })
            .addCase(vendorExcessDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportvendorExcessThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportvendorExcessThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportvendorExcessThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getvendorExcessStatisticsThunk.pending, (state) => {
                state.orderStatistics.loading = true;
            })
            .addCase(getvendorExcessStatisticsThunk.fulfilled, (state, action) => {
                state.orderStatistics.loading = false;
                state.orderStatistics.data = action.payload
            })
            .addCase(getvendorExcessStatisticsThunk.rejected, (state, action) => {
                state.orderStatistics.loading = false
            })
    },
});

export const { setvendorExcessrefresh, setvendorExcessPage, setvendorExcessSearch, setvendorExcessStatus, setvendorExcessFromDate, setvendorExcessToDate, setvendorExcessSelectedTab, setvendorExcessData } = vendorExcessSlice.actions
export default vendorExcessSlice.reducer;

